import React from 'react'

const defaultStyle = {};
const styleWithNoBorder = {border: 'none', background: '#fff', padding: 0};
const CheckoutSectionBody = ({ children, hideBodyBorder }) => (
  <div
    className="panel panel-default"
    style={hideBodyBorder ?  styleWithNoBorder : defaultStyle}
  >
    <div className="panel-body">
      {children}
    </div>
  </div>
)

export default CheckoutSectionBody